import * as React from 'react';
import { Tag } from 'Src/models/tag';

export const USER_TAG_DEFAULT_COLOR = '#2563EB';

export const USER_TAG_PALETTE = [
  '#2563EB',
  '#0F8A8A',
  '#2F9E5A',
  '#F08C1A',
  '#DA4453',
  '#7B5BD6',
  '#64748B',
  '#9E2718'
];

const HEX_COLOR_REGEXP = /^#[0-9a-fA-F]{6}$/;

export function normalizeUserTagColor(color?: string): string {
  const value = String(color || '').trim();
  return HEX_COLOR_REGEXP.test(value) ? value.toUpperCase() : USER_TAG_DEFAULT_COLOR;
}

export function getUserTagColor(tag?: Partial<Tag> | null): string {
  return normalizeUserTagColor(tag && tag.color);
}

export function getUserTagStyle(tag?: Partial<Tag> | null): React.CSSProperties {
  const color = getUserTagColor(tag);
  return {
    color,
    backgroundColor: `${color}1A`
  };
}

